<div class="saving-or-investment">
  <div class="row middle-xs between-xs">
    <div
      class="col-no-gutter"
    >
      <h4 class="saving-or-investment__title">{{label}}</h4>
    </div>
    <ng-container *ngIf="!readonly">
      <div class="col-sm-3 col-no-gutter">
        <mfp-button
          class="saving-or-investment__remove"
          color="secondary"
          [fill]="removeFill"
          [size]="removeSize"
          [icon]="removeIcon"
          [iconPosition]="removeIconPosition"
          [label]="removeLabel"
          (click)="remove()"
        ></mfp-button>
      </div>
    </ng-container>

  </div>
  <div [formGroup]="form">
    <div
      class="row"
    >
      <div
        class="col-xs-24 col-gutter-lr col-sm-6"
      >
        <mfp-input-currency
          [name]="amountName"
          [formControlName]="amountName"
          type="text"
          [view]="view"
          [label]="amountLabel"
          [currencyOptions]="currencyOptions"
          [success]="isFieldValid(form, amountName)"
          [error]="isFieldInvalid(form, amountName)"
          [helper]="getFieldError(form, amountName) | translate"
          [readonly]="readonly"
          [required]="required"
        ></mfp-input-currency>
      </div>
      <div
        class="col-xs-24 col-xs--no-margin col-gutter-lr col-sm-6"
      >
        <mfp-select
          [name]="typeName"
          [formControlName]="typeName"
          [view]="view"
          [label]="typeLabel"
          [placeholder]="typePlaceholder"
          [options]="typeOptions"
          [color]="typeColor"
          [success]="isFieldValid(form, typeName)"
          [error]="isFieldInvalid(form, typeName)"
          [helper]="getFieldError(form, typeName) | translate"
          [readonly]="readonly"
          [required]="required"
        ></mfp-select>
      </div>
    </div>
  </div>
</div>
